import React from 'react';
import cn from 'classnames';

import Checkbox from 'shared/ui/Checkbox/Checkbox';

import MonitorIconStatus from '../MonitorIconStatus/MonitorIconStatus';

import styles from './MonitorRowStatusCell.module.scss';

interface IMonitorRowStatusCellProps {
    isMassOperationsMode: boolean,
    hasSelectedItems: boolean,
    isSelected: boolean,
    onCheckboxChange: () => void,
    isPaused: boolean,
    ok?: boolean | null,
    incompleteResult?: boolean,
    checkboxClassName?: string,
}

const MonitorRowStatusCell: React.FC<IMonitorRowStatusCellProps> = ({
    isMassOperationsMode,
    hasSelectedItems,
    isSelected,
    onCheckboxChange,
    isPaused,
    ok,
    incompleteResult,
    checkboxClassName,
}) => (
    <td
        className={cn(styles.statusCell, hasSelectedItems && styles.hasSelectedItems)}
        onClick={(e) => e.stopPropagation()}
    >
        {isMassOperationsMode ? (
            <Checkbox
                onChange={onCheckboxChange}
                checked={isSelected}
                className={cn(styles.checkbox, checkboxClassName)}
            />
        ) : (
            <>
                <div className={styles.hoverStatus}>
                    <MonitorIconStatus isPaused={isPaused} ok={ok} incompleteResult={incompleteResult}/>
                </div>
                <div className={styles.hoverCheckbox}>
                    <Checkbox
                        onChange={onCheckboxChange}
                        checked={isSelected}
                    />
                </div>
            </>
        )}
    </td>
);

export default MonitorRowStatusCell;
